<script setup>
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { frontendURL } from 'dashboard/helper/URLHelper';

import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  bot: { type: Object, required: true },
});

const router = useRouter();
const route = useRoute();

// An AI agent never opens here: its bot page is the agent's own (AgentHeader). What is left is the
// flow or the service a bot runs, which answer from what was built into them, not from knowledge.
const brainUrl = computed(() => {
  if (props.bot.bot_type === 'flow' && props.bot.flow_id) {
    return frontendURL(
      `accounts/${route.params.accountId}/settings/flows/${props.bot.flow_id}`
    );
  }
  return '';
});
</script>

<template>
  <div class="flex flex-col gap-6">
    <div
      class="flex items-center gap-4 p-5 rounded-xl bg-n-solid-1 outline outline-1 outline-n-weak"
    >
      <div class="flex flex-col flex-grow min-w-0 gap-1">
        <span class="text-sm text-n-slate-11">
          {{ $t('AGENT_BOTS.BRAIN.RUNS') }}
        </span>
        <span class="text-base font-medium text-n-slate-12">
          {{ bot.flow_name || bot.outgoing_url || $t('AGENT_BOTS.BRAIN.NONE') }}
        </span>
      </div>
      <Button
        v-if="brainUrl"
        :label="$t('AGENT_BOTS.BRAIN.OPEN')"
        variant="outline"
        color="slate"
        size="sm"
        @click="router.push(brainUrl)"
      />
    </div>

    <p class="text-sm text-n-slate-11">
      {{ $t('AGENT_BOTS.BRAIN.NO_KNOWLEDGE') }}
    </p>
  </div>
</template>
